/* eslint-disable react/no-array-index-key */
import React from "react";

import HotelShortReview from "./HotelShortReview";
import HotelScoreRange from "../HotelScoreRange";

const renderAmenities = (amenities) =>
  amenities && (
    <p>
      <span className="alt">Équipements :</span> {amenities}
    </p>
  );

const renderShortReviews = ({ id, shortReviews }) => {
  if (!shortReviews.length) {
    return null;
  }

  const reviews = shortReviews.map((review, idx) => (
    <span key={`${id}-${idx}`}>
      <HotelShortReview text={review} />{" "}
    </span>
  ));

  return (
    <p itemProp="review" itemScope itemType="https://schema.org/Review">
      {reviews}
      <span
        itemProp="author"
        itemScope
        itemType="https://schema.org/Organization"
      >
        {" "}
        <meta property="name" content="Hôtel à Paris" />
      </span>
    </p>
  );
};

const renderScore = (score) =>
  score && (
    <p className="range-container">
      <span>Avis des clients :</span> <HotelScoreRange score={score} />
    </p>
  );

/* eslint-disable react/no-danger */
const ResultListCore = ({
  id,
  description,
  amenities,
  shortReviews,
  score,
}) => (
  <div>
    <div dangerouslySetInnerHTML={{ __html: description }} />
    {renderAmenities(amenities)}
    {renderShortReviews({
      id,
      shortReviews,
    })}
    {renderScore(score)}
  </div>
);

export default ResultListCore;
